import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { signin } from './stores/sign-in/sign-in-reducer';
import { route } from './stores/route/route-reducer';
import { Route, IndexRoute, Router, browserHistory } from 'react-router';
import { routerReducer, syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import React from 'react';
import ReactDOM from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import thunk from 'redux-thunk';
import SignInRouter from './components/signin/signin-container';
import SignIn from './components/signin/signin';
import SignInLink from './components/signin/links';
import EmailLink from './components/signin/email-link';
import sagas from './stores/sign-in/sign-in-sagas';

require('../less/main.less'); // FOR WEBPACK

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const logger = () => next => action => next(action);
const createStoreWithMiddleware = composeEnhancers(applyMiddleware(thunk, sagaMiddleware, logger, routerMiddleware(browserHistory)))(createStore);
const reducer = combineReducers({
  signin,
  route,
  routing: routerReducer,
});

const store = createStoreWithMiddleware(reducer);
sagaMiddleware.run(sagas);
// Needed for onTouchTap
// Can go away when react 1.0 release
// Check this repo:
// https://github.com/zilverline/react-tap-event-plugin
injectTapEventPlugin();
const history = syncHistoryWithStore(browserHistory, store);

/* jshint ignore:start */
  /* jshint ignore:start */
ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
         <Route path="/signin" component={SignInRouter}>
           <IndexRoute component={SignIn} />
           <Route component={SignIn} path="sso"/>
           <Route component={SignInLink} path="forgot-password"/>
           <Route component={SignInLink} path="resend-confirmation"/>
           <Route component={SignInLink} path="resend-secondary-confirmation-email"/>
           <Route component={SignInLink} path="disassociate-secondary"/>
           <Route component={SignInLink} path="newpassword/:token"/>
           <Route component={EmailLink} path="email/confirmation/:token"/>
           <Route component={EmailLink} path="email/secondary-confirmation/:token" />
           <Route component={EmailLink} path="email/confirm-disassociate/:token"/>
         </Route>
      </Router>
    </Provider>,
    document.getElementById('app')
  );

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/signin.jsx